<template>
  <div class="container">
    <div class="card-main">
      <div v-if="cardList && cardList.length > 0">
        <div class="card-box" v-for="(card, index) in cardList" :key="index">
          <div class="card-type-name">卡号：{{ card.userCardNo }}</div>
          <div class="card-grid" >
            <div class="card-grid-item" :class="checkIndex == item.packageNo ? 'active' : ''" v-for="(item, idx) in card.cardPackages" :key="idx" @click="goRouter(card, item)">
              <div class="card-grid-item-content flex-ccc">
                <div class="priceStr"><span class="fs-10">¥</span>{{ item.priceStr }}</div>
                <div v-if="card.cardType === '2'">{{item.times}}</div>
                <div v-if="item.donationStr > 0"> 送 {{ item.donationStr }}</div>
                <div class="tag" v-if="item.discount < 100">{{ item.discount/ 10 }}折</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-result" v-if="noData">
        <div class="no-result-img"></div>
        <div>您暂无会员卡，<span class="open-card" @click.stop="goOpenCard">点我去开卡</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import noData from '@/components/common/noData'
export default {
  name: 'rechargeCard',
  data () {
    return {
      cardList: [],
      checkIndex: -1,
      storeInfo: {},
      pickIndex: 0,
      storeIdStr: '',
      storeName: '',
      storeList: [],
      storeModal: false,
      router: '',
      noData: false
    }
  },
  created () {
    this.cardIndex()
  },
  methods: {
    cardIndex () {
      this.$api.pay.getCardAndPackages({
      }).then(res => {
        console.log('res', res)
        if (res.errCode === '0') {
          const { userCardPck = [] } = res.data
          this.cardList = userCardPck
          if (this.cardList.length > 0) {
            this.noData = false
          } else {
            this.noData = true
          }
          this.cardList.forEach(item => {
            item.cardPackages.forEach(card => {
              card.discountSrt = card.discount / 10
            })
          })
        } else {
          this.$toast(res.errMsg)
        }
      })
    },
    goOpenCard () {
      this.$router.push({ path: '/openCard' })
    },
    goRouter (card, item) {
      const {id, packageNo} = item
      const {id: userCardId, userCardNo} = card
      this.checkIndex = packageNo
      setTimeout(() => {
        this.checkIndex = -1
        this.$router.push({ path: '/cardDetail', query: { packageId: id, packageNo, userCardNo, userCardId } })
      }, 500)
    }
  },
  components: {
    noData
  }
}
</script>

<style scoped lang="stylus">
.container
  position relative
  min-height 100vh
  background #fff
  .top-bg
    width 100vw
    height 3px
    background:linear-gradient(150deg,#fc5a07,#fc9a07)
  .store-top
    padding 15px
    background #fff
    border-bottom  1px solid #e8e8e8
    margin-bottom 10px
    .picker
      font-size 12px
      span
        margin-right 10px
  .card-box
    padding 10px 15px
    &:not(:last-child)
      border-bottom 1px dashed #e8e8e8
    .card-type-name
      margin-bottom 14px
      padding 5px 8px
      line-height 1
      font-size 16px
      color #171717
      font-weight bold
  .card-grid
    display flex
    flex-wrap wrap
    .card-grid-item
      box-sizing border-box
      flex-basis 33.33%
      padding-right 5px
      margin-bottom 10px
      height 75px
      &.active
        .card-grid-item-content
          background:rgba(254,250,242,1);
          border:1px solid rgba(214,190,137,1);
      .card-grid-item-content
        position relative
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        border 1px solid #DAD8DA;
        border-radius 6px
        height: 100%;
        padding: 10px 8px;
        color: #A2A1A1;
        font-size 12px
        letter-spacing 1px
        .priceStr
          font-size 21px
          color #C2984C
          font-weight 500
        .tag
          position absolute
          right 0
          top -8px
          padding 1px 5px
          background:linear-gradient(150deg,#fc5248,#fa152d);
          color #fff
          font-size 12px
          border-radius 0 6px 0 6px
.store-name
  font-size 16px
  font-weight bold
  color #000
.exchange-icon
  margin 0 5px
.no-result
  padding-top 15vh
  text-align center
  font-size 16px
  .open-card
    text-decoration underline
  .no-result-img
    width 93px
    height 88px
    background-image url('https://kangaroo-book.oss-cn-hangzhou.aliyuncs.com/water-element-test/noData-coupon.png')
    background-size: 93px 88px
    background-position center
    margin 20px auto
</style>
